module.exports = "/assets/8e4f66103d4a2b6a0643b64752bb0d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BH.png
// module id = 2359
// module chunks = 0